(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    function initializeMobileNavigation(navigation) {
    if (navigation.dataset.tabsReady) return;
    navigation.dataset.tabsReady = 'true';
    const tabs = Array.from(navigation.querySelectorAll('[role="tab"]'));
    const panels = Array.from(navigation.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;
    const drawer = navigation.closest('header-drawer');
    const details = drawer.querySelector('details');
    const scroller = navigation.closest('.menu-drawer__navigation-container');

    function selectTab(tab, moveFocus = true, resetScroll = true) {
      const selectedPanel = tab.getAttribute('aria-controls');
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== selectedPanel; });
      if (resetScroll && scroller) scroller.scrollTop = 0;
      if (moveFocus) tab.focus({ preventScroll: true });
      const pageY = Number(drawer.dataset.btNavigationPageY);
      if (details.open && Number.isFinite(pageY) && window.scrollY !== pageY) {
        window.scrollTo({ top: pageY, behavior: 'instant' });
      }
    }

    details.addEventListener('toggle', () => {
      if (details.open) drawer.dataset.btNavigationPageY = String(window.scrollY);
    });
    navigation.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !tabs.includes(tab)) return;
      event.preventDefault();
      selectTab(tab);
    });
    navigation.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !tabs.includes(tab)) return;
      const index = tabs.indexOf(tab);
      let nextIndex;
      const rtl = getComputedStyle(navigation).direction === 'rtl';
      if (event.key === 'ArrowRight') nextIndex = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
      else if (event.key === 'ArrowLeft') nextIndex = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = tabs.length - 1;
      else if (event.key === ' ' || event.key === 'Enter') nextIndex = index;
      else return;
      event.preventDefault();
      selectTab(tabs[nextIndex]);
    });
    selectTab(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0], false, false);
  }

  document.querySelectorAll('.bt-mobile-navigation').forEach(initializeMobileNavigation);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.bt-mobile-navigation').forEach(initializeMobileNavigation);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    const btPreviewId = new URL(window.location.href).searchParams.get('preview_theme_id') ||
    (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null);
  if (btPreviewId && /^\d+$/.test(btPreviewId)) {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      if (anchor.getAttribute('href').startsWith('#')) return;
      let destination;
      try { destination = new URL(anchor.href, window.location.href); } catch { return; }
      if (destination.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|products|pages|search)(?:\/|$)/i.test(destination.pathname)) return;
      destination.searchParams.set('preview_theme_id', btPreviewId);
      anchor.href = destination.href;
    });
  }
  if (!customElements.get('bt-gallery-menu')) {
    customElements.define('bt-gallery-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.addEventListener('pointerenter', (event) => {
          clearTimeout(this.timer);
          if (event.pointerType === 'mouse' && matchMedia('(min-width: 990px) and (hover: hover)').matches) this.timer = setTimeout(() => this.setOpen(true), 140);
        }, options);
        this.addEventListener('pointerleave', () => {
          clearTimeout(this.timer);
          if (!this.contains(document.activeElement)) this.timer = setTimeout(() => this.setOpen(false), 240);
        }, options);
        this.summary.addEventListener('click', (event) => {
          event.preventDefault(); clearTimeout(this.timer); this.setOpen(!this.details.open);
        }, options);
        this.details.addEventListener('toggle', () => this.summary.setAttribute('aria-expanded', String(this.details.open)), options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault(); event.stopPropagation(); clearTimeout(this.timer); this.setOpen(false); this.summary.focus();
          }
        }, options);
        this.addEventListener('focusout', () => {
          setTimeout(() => { if (!this.contains(document.activeElement)) this.setOpen(false); }, 0);
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) { clearTimeout(this.timer); this.setOpen(false); }
        }, options);
        window.addEventListener('resize', () => {
          if (!matchMedia('(min-width: 990px)').matches) this.setOpen(false);
          else if (this.details.open) this.sizePanel();
        }, options);
      }
      sizePanel() {
        const panel = this.querySelector('.bt-gallery-panel');
        const trigger = this.summary.getBoundingClientRect();
        const origin = panel.offsetParent.getBoundingClientRect();
        const top = panel.getBoundingClientRect().top;
        this.style.setProperty('--bt-bridge-top', `${trigger.bottom - origin.top}px`);
        this.style.setProperty('--bt-bridge-left', `${trigger.left - origin.left}px`);
        this.style.setProperty('--bt-bridge-width', `${trigger.width}px`);
        this.style.setProperty('--bt-bridge-height', `${Math.max(0, top - trigger.bottom) + 2}px`);
        this.style.setProperty('--bt-panel-space', `${Math.max(160, innerHeight - top - 16)}px`);
      }
      setOpen(open) {
        this.details.open = open;
        if (open) {
          this.closest('nav').querySelectorAll('bt-gallery-menu').forEach((menu) => { if (menu !== this) menu.setOpen(false); });
          this.sizePanel();
        }
        this.summary.setAttribute('aria-expanded', String(open));
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
